module.exports = __webpack_public_path__ + "static/media/daa.69863f26.png";